import { Link } from 'react-router-dom'
import { articelsHomePageImages } from '../../services/images.service'
import { getAnimeDetailsUrl, getAnimeImage } from '../../services/util.service'
import { openNotRegisteredPopup } from '../../store/slices/ui.slice'
import { Year } from '../../assets/imgs/svg/AnimeDetails/mobile/Year'
import { MalScore } from '../../assets/imgs/svg/AnimeDetails/mobile/MalScore'
import { IsraelScore } from '../../assets/imgs/svg/AnimeDetails/mobile/IsraelScore'
import { AddToWatch } from '../../assets/imgs/svg/AnimeDetails/mobile/AddToWatch'
import { PlanToWatch } from '../../assets/imgs/svg/AnimeDetails/mobile/PlanToWatch'
import { WatchingOnline } from '../../assets/imgs/svg/AnimeDetails/mobile/WatchingOnline'
import { ReviewPopup } from '../ReviewSystem/ReviewPopup'
import { useSelector } from 'react-redux'
import { useMemo, useState } from 'react'
import { AddReview } from '../../assets/imgs/svg/AnimeDetails/desktop/AddReview'
import toast from 'react-hot-toast'
import { EditWatchlist } from '../../assets/imgs/svg/AnimeDetails/desktop/EditWatchlist'
import { EditReview } from '../../assets/imgs/svg/AnimeDetails/desktop/EditReview'
import { useWatchlistActions } from '../../hooks/useWatchlistActions'
import { AnimeWatchlistEdit } from '../UserProfile/UserWatchlist/AnimeWatchlistEdit'
import { MinusIcon, PlusIcon } from '../ui/icons/shared'


export function AnimeHeaderMobile({
  anime,
  handleAddItem,
  loggedInUser,
  dispatch,
  isInWatchlist,
  currentWatchItem,
  onIncrement,
  onDecrement,
  onRemove,
  onSaveChanges,
  canEdit,
}) {
  const [showReviewPopup, setShowReviewPopup] = useState(false)
  const [initialReviewData, setInitialReviewData] = useState(null)
  const [showEditWatchlist, setShowEditWatchlist] = useState(false)
  const [editData, setEditData] = useState(null)

  const { getUpdatedWatchItem } = useWatchlistActions(loggedInUser?._id)
  const reviews = useSelector((state) => state.reviewModule.reviews) || []

  const filteredReviews = reviews.filter(
    (review) => review.animeId === anime.anizone_id
  )

  const userAlreadyReviewed = useMemo(() => {
    if (!loggedInUser) return false
    return filteredReviews.some((review) => review.userId === loggedInUser._id)
  }, [filteredReviews, loggedInUser])

  const statuses = [
    { value: 'Watching', label: 'כרגע צופה' },
    { value: 'Plan to Watch', label: 'מתכנן לצפות' },
    { value: 'Completed', label: 'סיימתי לצפות' },
    { value: 'On-Hold', label: 'בהמתנה' },
    { value: 'Dropped', label: 'ננטש' },
  ]

  const currentStatusLabel = currentWatchItem
    ? statuses.find((status) => status.value === currentWatchItem.status)?.label
    : null

  const handleWriteReview = () => {
    if (!loggedInUser) {
      toast.error('עליך להיות מחובר כדי לכתוב ביקורת.')
      dispatch(openNotRegisteredPopup())
      return
    }

    const existingReview = filteredReviews.find(
      (review) =>
        review.animeId === anime.anizone_id &&
        review.userId === loggedInUser._id
    )
    setInitialReviewData(existingReview || null)
    setShowReviewPopup(true)
  }

  const handleEditWatchlist = () => {
    if (!currentWatchItem) return
    setEditData({
      progress: currentWatchItem.progress,
      status: currentWatchItem.status,
    })
    setShowEditWatchlist(true)
  }

  const handleSaveWatchlistChanges = () => {
    const updatedItem = getUpdatedWatchItem({
      ...currentWatchItem,
      ...editData,
    })
    onSaveChanges(updatedItem)
    setShowEditWatchlist(false)
  }

  const averageRatingIL = useMemo(() => {
    if (!filteredReviews.length) return '0'
    const total = filteredReviews.reduce(
      (sum, review) => sum + review.rating,
      0
    )
    return (total / filteredReviews.length).toFixed(2)
  }, [filteredReviews])
  return (
    <section className="flex flex-col">
      <nav className="text-sm text-softText">
        <ol className="flex items-center gap-4">
          <li>
            <Link to="/" className="hover:underline">
              בית
            </Link>
          </li>
          <img src={articelsHomePageImages.arrowIcon} alt="arrow" />
          <li>
            <Link to="/animes" className="hover:underline">
              אנימות
            </Link>
          </li>
          <img src={articelsHomePageImages.arrowIcon} alt="arrow" />
          <li>
            <Link
              to={getAnimeDetailsUrl(anime)}
              className="text-muted hover:underline"
            >
              {anime.title_hebrew || anime.title_english || anime.title}
            </Link>
          </li>
        </ol>
      </nav>
      <div className="flex flex-col items-center mt-4">
        <div className="text-center max-w-[350px">
          <h1 className="text-white text-5xl">
            {anime.title_hebrew || anime.title_english}
          </h1>
          <h3 className="text-xl mb-6">{anime.title || anime.title_english}</h3>
        </div>

        <div className="flex flex-col gap-4 w-[180px] relative">
          <div className="absolute -translate-y-[40%] right-[-20%]">
            <Year anime={anime} />
          </div>
          <img
            src={getAnimeImage(anime)}
            className="w-full h-[280px] object-cover"
            alt={`${anime.title_english || anime.title} Cover Image`}
          />
          <div className=" flex items-center justify-center ">
            <div className="flex gap-2">
              <div className="flex flex-col gap-4">
                <MalScore />

                <div className="text-center text-2xl">
                  <span className="text-muted">10 / </span>{' '}
                  <span className="text-softText">{anime.score || 0}</span>
                </div>
              </div>

              <div className="flex flex-col gap-4">
                <IsraelScore />

                <div className="text-center text-2xl">
                  <span className="text-muted">10 / </span>{' '}
                  <span className="text-softText">{averageRatingIL}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-4 mt-4">
          <div className="border-b-2 h-[86px] w-[109px] border-primary bg-gradient-to-tr from-[#252525] to-[#1B1B1B] shadow-[0px_0px_2.1px_0px_rgba(0,0,0,0.56)] flex items-center justify-center">
            <div className="flex flex-col gap-4 text-center text-softText text-sm">
              <span>דירוג</span>#{anime.rank}
            </div>
          </div>

          <div className="border-b-2 h-[86px] w-[109px] border-primary bg-gradient-to-tr from-[#252525] to-[#1B1B1B] shadow-[0px_0px_2.1px_0px_rgba(0,0,0,0.56)] flex items-center justify-center">
            <div className="flex flex-col gap-4 text-center text-softText text-sm">
              <span>פופולריות</span>#{anime.popularity}
            </div>
          </div>

          <div className="border-b-2 h-[86px] w-[109px] border-primary bg-gradient-to-tr from-[#252525] to-[#1B1B1B] shadow-[0px_0px_2.1px_0px_rgba(0,0,0,0.56)] flex items-center justify-center">
            <div className="flex flex-col gap-4 text-center text-softText text-sm">
              <span>צופים</span>
              {Intl.NumberFormat('he-IL').format(anime.members)}
            </div>
          </div>
        </div>

        <div className="flex flex-col justify-center w-[320px] items-center mt-8 gap-4">
          {!isInWatchlist && (
            <>
              {/* רשימת צפייה */}
              <button onClick={() => handleAddItem('Watching', anime)}>
                <AddToWatch />
              </button>
              {/* מתכנן צפייה */}
              <button onClick={() => handleAddItem('Plan to Watch', anime)}>
                <PlanToWatch />
              </button>
            </>
          )}
          {isInWatchlist && (
            <>
              <span className="w-full h-[2px] bg-[rgba(255,255,255,0.15)]"></span>
              {currentStatusLabel && (
                <div className="flex flex-col items-center gap-2 justify-center">
                  <span className="text-softText text-lg">
                    {currentStatusLabel}
                  </span>
                </div>
              )}

              {currentWatchItem && (
                <div className="flex gap-2 items-center">
                  {canEdit && onDecrement && onIncrement ? (
                    <>
                      <button
                        onClick={() => onDecrement(currentWatchItem)}
                        className="w-6 h-6 bg-accentLight rounded-full flex items-center justify-center"
                      >
                        <MinusIcon />
                      </button>
                      <span className="text-softText">
                        {anime.episodes || '??'} / {currentWatchItem.progress}
                      </span>
                      <button
                        onClick={() => onIncrement(currentWatchItem)}
                        className="w-6 h-6 bg-accentLight rounded-full flex items-center justify-center"
                      >
                        <PlusIcon />
                      </button>
                    </>
                  ) : (
                    <span className="text-softText">
                      {currentWatchItem.progress} / {anime.episodes || '??'}
                    </span>
                  )}
                </div>
              )}

              <button onClick={handleEditWatchlist}>
                <EditWatchlist />
              </button>
              <span className="w-full h-[2px] bg-[rgba(255,255,255,0.15)]"></span>

              <button onClick={handleWriteReview}>
                {userAlreadyReviewed ? <EditReview /> : <AddReview />}
              </button>
            </>
          )}
        </div>
        {anime.streaming.find(
          (s) => s.name === 'Crunchyroll' || s.name === 'Netflix'
        ) && (
          <div className="flex flex-col items-center">
            <a
              href={
                anime.streaming.find((s) => s.name === 'Crunchyroll')?.url ||
                anime.streaming.find((s) => s.name === 'Netflix')?.url ||
                '#'
              }
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center"
              onClick={(e) => {
                // נניח שיש לך סטייט או useSelector לשם בדיקת התחברות המשתמש
                if (!loggedInUser) {
                  e.preventDefault()
                  dispatch(openNotRegisteredPopup())
                }
              }}
            >
              <WatchingOnline />
            </a>
          </div>
        )}
        {showReviewPopup && (
          <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
            <ReviewPopup
              initialData={initialReviewData}
              animeId={anime.anizone_id}
              loggedInUser={loggedInUser}
              onClose={() => setShowReviewPopup(false)}
            />
          </div>
        )}

        {showEditWatchlist && currentWatchItem && editData && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <AnimeWatchlistEdit
              item={currentWatchItem}
              editData={editData}
              setEditData={setEditData}
              handleSaveItemChanges={(updatedItem) => {
                onSaveChanges(updatedItem)
                setShowEditWatchlist(false)
              }}
              getUpdatedWatchItem={getUpdatedWatchItem}
              handleCloseEdit={() => setShowEditWatchlist(false)}
              handleOpenReviewPopup={() => {}}
              userAlreadyReviewed={() => false}
              onRemove={(anizoneId) => {
                onRemove(anizoneId)
                setShowEditWatchlist(false)
              }}
            />
          </div>
        )}
      </div>
    </section>
  )
}
